var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarvinIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0005,
    cy: 14.0007,
    r: 14.0005,
    fill: "url(#paint0_linear_1444_102897)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32006 8.03035C6.03867 7.74771 5.94043 7.33069 6.06607 6.95216L6.10017 6.84943C6.23663 6.4383 6.57893 6.12902 7.00174 6.03481L7.02169 6.03037C7.4409 5.93696 7.8789 6.06204 8.18556 6.36275L13.8459 11.9131L15.3979 10.4679L16.9297 11.9353L14.6735 13.9474C14.4309 14.1637 14.1173 14.2832 13.7923 14.2832C13.4636 14.2832 13.1467 14.1609 12.9031 13.9402L7.66589 9.19302L7.69735 9.21668L6.32006 8.03035Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8983 11.0716L16.3464 9.58482L19.8161 6.3541C20.0565 6.13027 20.3727 6.00583 20.7012 6.00583C21.4185 6.00583 22 6.58733 22 7.30466V20.3433C22 20.9229 21.5302 21.3927 20.9506 21.3927C20.3718 21.3927 19.9023 20.924 19.9013 20.3452L19.8816 9.30295L17.8983 11.0716Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31434 19.7032C9.31434 19.5872 9.30243 19.474 9.27977 19.3648L10.7457 17.7987C10.9386 17.8774 11.1496 17.9207 11.3708 17.9207C12.2861 17.9207 13.028 17.1788 13.028 16.2636C13.028 15.3483 12.2861 14.6064 11.3708 14.6064C11.1691 14.6064 10.9758 14.6424 10.797 14.7084L9.29914 13.2106C9.30916 13.1369 9.31434 13.0616 9.31434 12.9852C9.31434 12.0699 8.5724 11.328 7.65717 11.328C6.74194 11.328 6 12.0699 6 12.9852C6 13.5553 6.28787 14.0581 6.72618 14.3563L6.72619 18.332C6.28788 18.6302 6 19.1331 6 19.7032C6 20.6184 6.74194 21.3603 7.65717 21.3603C8.5724 21.3603 9.31434 20.6184 9.31434 19.7032ZM8.29466 12.9852C8.29466 13.3372 8.00924 13.6227 7.65717 13.6227C7.30509 13.6227 7.01968 13.3372 7.01968 12.9852C7.01968 12.6331 7.30509 12.3477 7.65717 12.3477C8.00924 12.3477 8.29466 12.6331 8.29466 12.9852ZM8.09711 14.5833L8.09713 18.105C8.21957 18.1387 8.33635 18.186 8.44571 18.2453L9.80138 16.797C9.74451 16.6296 9.71367 16.4502 9.71367 16.2636C9.71367 16.0564 9.75169 15.8581 9.82114 15.6752L8.53617 14.3903C8.40158 14.4746 8.254 14.5402 8.09711 14.5833ZM11.3708 16.901C11.2269 16.901 11.0942 16.8534 10.9875 16.7729L10.8846 16.6759C10.7903 16.5647 10.7333 16.4208 10.7333 16.2636C10.7333 15.9115 11.0188 15.6261 11.3708 15.6261C11.7229 15.6261 12.0083 15.9115 12.0083 16.2636C12.0083 16.6156 11.7229 16.901 11.3708 16.901ZM7.65717 20.3407C8.00924 20.3407 8.29466 20.0552 8.29466 19.7032C8.29466 19.3511 8.00924 19.0657 7.65717 19.0657C7.30509 19.0657 7.01968 19.3511 7.01968 19.7032C7.01968 20.0552 7.30509 20.3407 7.65717 20.3407Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1444_102897",
    x1: -0.786543,
    y1: 0.000209476,
    x2: 30.0051,
    y2: 1.41013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00148221,
    stopColor: "#C5A5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992268,
    stopColor: "#F1C7AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvinIconDisabled);
export default __webpack_public_path__ + "static/media/Marvin Icon-disabled.1a3e5fddabb341bb7d1f8df07249597a.svg";
export { ForwardRef as ReactComponent };